// @flow
import React from "react"
import classnames from "classnames"

import RadioButtonsRadio from "./RadioButtonsRadio"
import type { RadioButtonMode } from "./RadioButtons.types"

type Props = {
  mode: RadioButtonMode,
  handleChange: string => void,
  active?: string,
  forcedValue?: string,
}

const RadioButtonsOption = ({
  mode: { value, disabled, customClass = "", icon, label, cssClass = "", customLabel, element },
  active,
  handleChange,
  forcedValue,
}: Props) => (
  <label
    className={classnames("RadioButtonsOption", {
      _checked: value === active,
      _disabled: disabled,
      [customClass]: customClass,
    })}
  >
    <RadioButtonsRadio
      checked={value === active || forcedValue === active}
      onChange={() => {
        handleChange(forcedValue || value)
      }}
      value={forcedValue || value}
      disabled={disabled}
    />
    {icon && <i className={`RadioButtonsOption-icon ${icon}`} />}
    {label && <div className={`RadioButtonsOption-label spTypo-bold ${cssClass}`}>{label}</div>}
    {/* TODO: this is really stupid check, but it's a beta ¯\_(ツ)_/¯ */}
    {label === "Nomad" && <sub className="RadioButtonsOption-label-sub">BETA</sub>}
    {customLabel && <div className="RadioButtonsOption-customLabel">{customLabel}</div>}
    {element}
  </label>
)

export default RadioButtonsOption
